import PackageNewCard from './comp/PackageNewCard';
import './PackageListingPage.css'
import { BsArrowLeft } from "react-icons/bs";

import hero from "./image/food-img.png";
import './PartyPackageListingPage.css';
import searchIcon from './image/search-icon.svg'
import { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';

import { FiSettings } from "react-icons/fi";
import { FaHeart, FaUsers, FaRupeeSign, FaHistory, FaStar } from "react-icons/fa";
import { IoIosArrowDown } from "react-icons/io";
import { RxDotFilled } from "react-icons/rx";
import FilterBar from './FilterBar';
import FilterModal from './FilterModel';
import { API_BASE_URL } from '../utils';

export default function PackageListingPage() {


    const params = useParams();
    const navigate = useNavigate();

    let readableTitle = "Party Packages";

    const location = useLocation();
    const pathname = location.pathname;
    const { id, city, title } = params;


    const cityParams = city?.replace(/-/g, ' ');
    const titleParams = title?.replace(/-/g, ' ');

    if (id) {
        readableTitle = id?.replace(/-/g, ' ');
    }
    else if (city || title) {
        readableTitle = titleParams + " " + "Packages";
    }
    // const encodedTitle = pathname.split("/").pop();

    const pageName = readableTitle;

    const [data, setData] = useState([]);
    const [latitude, setLatitude] = useState("");
    const [longitude, setLongitude] = useState("");
    const [keyword, setKeyword] = useState("");
    const [selectedMenuIds, setSelectedMenuIds] = useState([]);
    const [titleData, setTitleData] = useState([]);
    const [selectedTitle, setSelectedTitle] = useState("Imported Drinks + Food");
    const [filtersAndSort, setFiltersAndSort] = useState({});

    const [showFilter, setShowFilter] = useState(false);


    const [visibleCount, setVisibleCount] = useState(6);

    const loaderRef = useRef(null);


    const [packageTitleAndId, setPackageTitleAndId] = useState([]);
    useEffect(() => {
        axios
            .get(`${API_BASE_URL}/master/APIs/Common/getAllPackageTitle`)
            .then((response) => {
                setPackageTitleAndId(response.data.data)
            })
            .catch((error) => console.log(error));
    }, []);


    const fetchPackagesByTitleCity = (latitude, longitude, city, title) => {
        const formData = new FormData();

        formData.append("latitude", latitude);
        formData.append("longitude", longitude);
        formData.append("city", city);
        formData.append("title", title);

        axios
            .post(`${API_BASE_URL}/master/APIs/ClubPackage/getPackagesByCityAndTitle`, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            })
            .then((response) => {
                if (response.data.status === true) {
                    setData(response.data.data);
                } else {
                    setData([]);
                }
            })
            .catch((error) => {
                console.log(error);
            });
    };




    const fetchData = (latitude, longitude, selectedMenuIds = [], matchedPackage) => {
        const formData = new FormData();

        formData.append("latitude", latitude);
        formData.append("longitude", longitude);
        formData.append("venue_id", Array.isArray(selectedMenuIds) ? selectedMenuIds.join(",") : "");
        formData.append("title_id", matchedPackage ? matchedPackage : "");
        formData.append("keyword", keyword || ""); // Optional keyword fallback

        axios
            .post(`${API_BASE_URL}/master/APIs/ClubPackage/allPackages`, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            })
            .then((response) => {
                if (response.data.status === true) {
                    setData(response.data.data);
                } else {
                    setData([]);
                }
            })
            .catch((error) => {
                console.log(error);
            });
    };




    useEffect(() => {
        if ("geolocation" in navigator) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    const { latitude, longitude } = position.coords;
                    setLatitude(latitude.toString());
                    setLongitude(longitude.toString());

                    const matchedPackage = packageTitleAndId?.find(
                        (item) => item.name.trim().toLowerCase() === readableTitle.trim().toLowerCase()
                    );


                    if (cityParams && titleParams) {
                        fetchPackagesByTitleCity(latitude, longitude, cityParams, titleParams);
                    } else if (matchedPackage) {
                        fetchData(latitude, longitude, [], matchedPackage?.id);
                    }
                    else {
                        fetchData(latitude, longitude);
                    }

                },
                (error) => {
                    console.error("Error getting location:", error);
                }
            );
        } else {
            console.error("Geolocation is not available in this browser.");
        }
    }, [readableTitle, cityParams, titleParams, packageTitleAndId]);


    // const handleClick = (title) => {
    //     const formattedTitle = title.name
    //         .toLowerCase()
    //         .replace(/[^a-z0-9\s]/gi, "")
    //         .trim()
    //         .replace(/\s+/g, "-");

    //     setSelectedTitle(title.name);
    //     navigate(`/party-packages-${formattedTitle}`);
    // };


    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setVisibleCount((prev) => prev + 6);
                }
            },
            { threshold: 1 }
        );

        if (loaderRef.current) {
            observer.observe(loaderRef.current);
        }

        return () => {
            if (loaderRef.current) observer.unobserve(loaderRef.current);
        };
    }, []);


    useEffect(() => {
        axios
            .get(`${API_BASE_URL}/master/APIs/ClubPackage/getPackageTypes`)
            .then((response) => {
                setTitleData(response.data.data);
            })
            .catch((error) => {
                console.log(error);
            });
    }, []);


    function generateClubUrl(clubName, cityName, areaName, title) {
        const format = (str) => (str ? str.trim().replace(/\s+/g, "-").toLowerCase() : "");

        return `/party-package/${format(clubName)}-${format(cityName)}-${format(areaName)}/${format(title)}`;
    }




    const fetchDataWithFilters = () => {
        const venueIds = filtersAndSort?.venue || [];
        const packageIds = filtersAndSort?.package || [];
        fetchData(latitude, longitude, venueIds, packageIds);
    };


    function getDistanceFromLatLonInKm(lat1, lon1, lat2, lon2) {
        if (
            lat1 == null || lon1 == null ||
            lat2 == null || lon2 == null
        ) {
            return 0;
        }

        const toRad = (value) => (value * Math.PI) / 180;
        const R = 6371; // Earth radius in km

        const dLat = toRad(lat2 - lat1);
        const dLon = toRad(lon2 - lon1);

        const a =
            Math.sin(dLat / 2) ** 2 +
            Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) *
            Math.sin(dLon / 2) ** 2;

        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        const distance = R * c;

        return distance;
    }

    const DistacneWiseData = data.sort((a, b) => getDistanceFromLatLonInKm(latitude, longitude, a.clubLat, a.clubLong) - getDistanceFromLatLonInKm(latitude, longitude, b.clubLat, b.clubLong));


    const filteredData = DistacneWiseData.filter((item) => {
        if (filtersAndSort.selectedDropdowns?.Review) {
            const selectedReview = parseInt(filtersAndSort.selectedDropdowns.Review[0]);
            const itemRating = parseFloat(item.totalAverageRating);

            const lowerBound = selectedReview - 0.4;
            const upperBound = selectedReview + 0.5;

            if (isNaN(itemRating) || itemRating < lowerBound || itemRating >= upperBound) {
                return false;
            }
        }


        // if (filtersAndSort.selectedPills.includes("Friends Favorite") && !item.isFriendFavorite) {
        //     return false;
        // }

        // if (filtersAndSort.selectedPills.includes("Under 999") && item.price >= 999) {
        //     return false;
        // }

        return true;
    }).sort((a, b) => {
        const sortType = filtersAndSort.selectedDropdowns?.["Sort By"];
        if (sortType === "A to Z") return a.title.localeCompare(b.title);
        if (sortType === "Z to A") return b.title.localeCompare(a.title);
        return 0;
    });




    return (
        <>
            <div className='PackageListingPage'>
                <div className='PackageListingPage_inside-text'>
                    <h1><BsArrowLeft  onAbort={() => navigate(-1)}/> Party Packages listing</h1>
                </div>
                <div className='PackageListingPage_inside-cards-section'>
                    
                        {data.length === 0 ? (
                            Array.from({ length: 1 }).map((_, index) => (
                                <p>Loading..</p>
                            ))
                        ) : (
                            filteredData.slice(0, visibleCount).map((item, index) => (
                                <Link
                                    to={generateClubUrl(item.clubName, item.cityName, item.areaName, item.title)}
                                    key={index} style={{ textDecoration: 'none', width: '100%' }}
                                >
                                    <PackageNewCard data={item} isListingPage={true} isVenueList={false} latitude={latitude} longitude={longitude} />
                                </Link>
                            ))

                        )}
                        <div ref={loaderRef} style={{ height: "1px" }} />
                  
                </div>
            </div>
        </>
    )
}
